export const getLoginBannerItems = (data, portal) =>
  data?.portal === portal && Array.isArray(data.items)
    ? data.items.filter((item) => item?.portal === portal)
    : [];

export const requireLoginBannerPortal = (data, portal) => {
  if (data?.portal !== portal) {
    throw new Error("A API do servidor precisa ser atualizada para gerenciar os banners deste portal.");
  }
  return getLoginBannerItems(data, portal);
};
